export default __webpack_public_path__ + "images/f412f2516993c1e642d380c44079922f-valentine_dsrp_mobile.webp";